import { MealPlanList } from "@corpuscomplete/core-ui/nutrition/meal-plan/list";
import { MealPlansPage } from "@corpuscomplete/web/modules/nutrition/meal-plan/pages/meal-plans";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/meal-plans/")({
  component: MealPlansPage,
  loader: async ({ context: { zero, actor } }) => {
    if (zero) {
      MealPlanList.preload(zero, actor.userId);
    }
  },
});
